import { render, staticRenderFns } from "./OrientationSelection.vue?vue&type=template&id=678e8bf2&scoped=true&"
import script from "./OrientationSelection.vue?vue&type=script&lang=js&"
export * from "./OrientationSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e8bf2",
  null
  
)

export default component.exports